module.exports = __webpack_public_path__ + "media/images/btn_google_signin_light_normal_web-c48ded8e0dbce33a26752d3d4d25d38c.png";